import React from "react";
import Social from "./Social";
export default function About() {
    return (
        <section id="about">
            <h1>We're rebuilding... Please check back soon</h1>
            <figure>
                <img src="https://cdn.sanity.io/images/7w3d3ntx/production/5e6f891b3e756461d1adabf81360f63da08d09fd-480x480.gif" alt="under construction" />
                <figcaption><a href="https://giphy.com/gifs/8KWG2s3MR6SXbjccBO?utm_source=media-link&utm_medium=landing&utm_campaign=Media%20Links&utm_term=">via Jon Frickey on GIPHY</a></figcaption>
            </figure>
            <header className="section-header">
                <h2>About Hippie Modernism</h2>
                <h3>Hippie Modernism is a devotional to the Radical architects, artists, and designers of the 1960's and 1970's</h3>
            </header>
            <div className="section-content disclaimer">
                <small>Copyright Disclaimer under Section 107 of the copyright act 1976, allowance is made for fair use for purposes such as criticism, comment, news reporting, scholarship, and research. Fair use is a use permitted by copyright statute that might otherwise be infringing. Non-profit, educational or personal use tips the balance in favour of fair use.</small>
            </div>
            <div className="section-content social">
                <Social />
            </div>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/components/About.js